const scheduledTask = {
    namespaced: true,
    state: {
        scheduledTaskList: [],
        taskTypeList: [],
        scheduleTypeList: [],
        selectedTask: null
    },
    mutations: {
        updateScheduledTaskList(state, newList) {
            state.scheduledTaskList = newList;
        },
        updateTaskTypeList(state, newList) {
            state.taskTypeList = newList;
        },
        updateScheduleTypeList(state, newList) {
            state.scheduleTypeList = newList;
        },
        changeSelectedTask(state, task) {
            state.selectedTask = task;
        }
    },
    actions: {
        getScheduledTaskList(context) {
            this._vm.$traveller_http.get('/traveller/restui/scheduler/schedule/getScheduledTasks')
                .then(function(response) {
                    context.commit('updateScheduledTaskList', response.data);
                })
        },
        getTaskTypeList(context) {
            this._vm.$traveller_http.get('/traveller/restui/scheduler/schedule/getScheduledTaskTypes')
                .then(function(response) {
                    context.commit('updateTaskTypeList', response.data);
                })
        },
        getScheduleTypeList(context) {
            this._vm.$traveller_http.get('/traveller/restui/scheduler/schedule/getScheduleTypes')
                .then(function(response) {
                    context.commit('updateScheduleTypeList', response.data);
                })
        },
        selectTask(context, task) {
            this._vm.$traveller_http.get('/traveller/restui/scheduler/schedule/getScheduledTask', { params: { "taskid": task.scheduledTaskId } })
                .then(function(response) {
                    task.taskParameters = response.data.taskParameters;
                    task.scheduleParameters = response.data.scheduleParameters;
                    context.commit('changeSelectedTask', task);
                });
        },
        saveTask(context, newTask) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/scheduler/schedule/saveScheduledTask', newTask)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getScheduledTaskList');
                        }
                        resolve(response);
                        context.commit('changeSelectedTask', null);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        deleteTask(context, scheduledTaskId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/scheduler/schedule/deleteScheduledTask', { params: { "taskid": scheduledTaskId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getScheduledTaskList');
                        }
                        resolve(response);
                        context.commit('changeSelectedTask', null);
                    }),
                error => {
                    reject(error);
                }
            });
        }
    }
}

export default scheduledTask;